import { render, staticRenderFns } from "./StatsTopCard.vue?vue&type=template&id=355cb450"
import script from "./StatsTopCard.vue?vue&type=script&lang=js"
export * from "./StatsTopCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports